import queryString from 'query-string';
import { apiFetch } from './utils';

export const illiquidSecurities = {
  get: async (args) => {
    const options = {
      method: 'GET',
    };

    const query = queryString.stringify(args, { arrayFormat: 'comma' });

    const url = `/v3/illiquid-securities?${query}`;

    const { body } = await apiFetch(url, {
      ...options,
    });

    return body;
  },
};
